import { createContext, useCallback, useContext, useMemo, useState } from "react";

function usePivotDataHookFactory() {
  const [cols, setCols] = useState([])
  const [rows, setRows] = useState([])
  const [metric, setMetric] = useState("")
  const [formatter, setFormatter] = useState("number")
  const [showHeatmap, setShowHeatmap] = useState(false)
  const [heatmapColor, setHeatmapColor] = useState("blue")
  const [sort, setSort] = useState("")
  const [aggregator, setAggregator] = useState("")

  const onChagePivotData = useCallback(update => {
    const { cols, rows, metric, formatter, showHeatmap, heatmapColor, sort, aggregator } = update
    cols && setCols(cols)
    rows && setRows(rows)
    metric && setMetric(metric)
    formatter && setFormatter(formatter)
    showHeatmap !== undefined && setShowHeatmap(showHeatmap)
    heatmapColor && setHeatmapColor(heatmapColor)
    sort && setSort(sort)
    aggregator && setAggregator(aggregator)
  }, [])

  return useMemo(() => ({
    cols, rows, metric, formatter, showHeatmap, heatmapColor, sort, aggregator, onChagePivotData,
  }), [cols, rows, metric, formatter, showHeatmap, heatmapColor, sort, aggregator, onChagePivotData])
}

const Context = createContext({})
const usePivotData = () => useContext(Context)

const PivotDataProvider = ({ children }) => {
  const value = usePivotDataHookFactory()

  return <Context.Provider value={value}>
    {children}
  </Context.Provider>
}

export {
  usePivotData,
  PivotDataProvider,
}
